var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info && _vm.info.resume && _vm.info.resume.file)?_c('div',{staticClass:"jin-m-resume"},[_c('p',{staticClass:"name",on:{"click":function($event){return _vm.$router.push({
      path: '/list/resume/Resume',
      query: {
        type: _vm.$route.query.type
      }
    })}}},[_c('span',[_vm._v("上传成功")]),_c('Icon',{attrs:{"name":"arrow-right"}})],1),_c('div',{staticClass:"jin-m-resume-item"},[_c('img',{attrs:{"src":require("@/assets/resume/resume.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.info.resume.file.name)+" ("+_vm._s(_vm.handleSize(_vm.info.resume))+")")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }